import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["menu"]

  toggle() {
    if (this.hasMenuTarget) {
      this.menuTarget.classList.toggle("hidden")
    } else {
      // Si le target n'est pas trouvé, chercher le menu mobile dans le DOM
      const mobileMenu = document.querySelector('[data-mobile-menu-target="menu"]')
      if (mobileMenu) {
        mobileMenu.classList.toggle("hidden")
      }
    }
  }

  close() {
    if (this.hasMenuTarget) {
      this.menuTarget.classList.add("hidden")
    }
  }
}
